// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "../core/Env.res.js";
import * as I18n from "../primitives/I18n.res.js";
import * as Json from "../primitives/Json.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Request from "../core/Request.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as PaymentMethod from "./PaymentMethod.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as FiscalYearOpeningMonth from "./FiscalYearOpeningMonth.res.js";

function decodeFromJson(json) {
  let dict = Json.decodeDict(json);
  if (dict === undefined) {
    return;
  }
  let maybePaymentMethod = Stdlib_Option.flatMap(dict["paymentMethod"], PaymentMethod.decodeFromJson);
  let maybeAccountNumber = Json.decodeDictFieldString(dict, "accountNumber");
  let maybeAccountLabel = Json.decodeDictFieldString(dict, "label");
  let isaComptaJournalCode = Json.decodeDictFieldString(dict, "isaComptaJournalCode");
  if (maybePaymentMethod !== undefined && maybeAccountNumber !== undefined && maybeAccountLabel !== undefined) {
    return {
      paymentMethod: maybePaymentMethod,
      accountNumber: maybeAccountNumber,
      accountLabel: maybeAccountLabel,
      isaComptaJournalCode: isaComptaJournalCode
    };
  }
}

function encodeToJson(value) {
  let dict = Object.fromEntries([
    [
      "paymentMethod",
      PaymentMethod.encodeToJson(value.paymentMethod)
    ],
    [
      "accountNumber",
      Json.encodeString(value.accountNumber)
    ],
    [
      "label",
      Json.encodeString(value.accountLabel)
    ]
  ]);
  let isaComptaJournalCode = value.isaComptaJournalCode;
  dict["isaComptaJournalCode"] = isaComptaJournalCode !== undefined ? Json.encodeString(isaComptaJournalCode) : null;
  return Json.encodeDict(dict);
}

let PaymentAccount = {
  decodeFromJson: decodeFromJson,
  encodeToJson: encodeToJson
};

function autocompleteBasicPaymentsAccounts(vendor) {
  return [
    [
      "Cash",
      "5810000000",
      "R1"
    ],
    [
      "Cheque",
      "5820000000",
      "R2"
    ],
    [
      "DebitCard",
      "5830000000",
      "R3"
    ],
    [
      "BankTransfer",
      "5860000000",
      "R6"
    ]
  ].map(param => {
    let paymentMethod = param[0];
    let tmp;
    tmp = vendor === "Excel" ? undefined : param[2];
    return {
      paymentMethod: paymentMethod,
      accountNumber: param[1],
      accountLabel: I18n.template(I18n.t("Payment {{paymentMethod}}"), {
        paymentMethod: PaymentMethod.toLabel(paymentMethod)
      }, undefined),
      isaComptaJournalCode: tmp
    };
  });
}

function fillWithStandard(taxRate, taxId) {
  if (taxRate < 5.5) {
    if (taxRate === 0) {
      return {
        taxId: taxId,
        isaComptaCode: "Y",
        productsSold: [
          "70700000",
          "Ventes marchandises TVA 0%"
        ],
        deductibleTax: undefined
      };
    }
    if (taxRate === 2.1) {
      return {
        taxId: taxId,
        isaComptaCode: "V3",
        productsSold: [
          "70780000",
          "Ventes marchandises TVA 2.1%"
        ],
        deductibleTax: [
          "4457180000",
          "TVA collectée 2.1%"
        ]
      };
    }
  } else {
    if (taxRate === 5.5) {
      return {
        taxId: taxId,
        isaComptaCode: "V2",
        productsSold: [
          "70700000",
          "Ventes marchandises TVA 5.5%"
        ],
        deductibleTax: [
          "4457100000",
          "TVA collectée 5.5%"
        ]
      };
    }
    if (taxRate === 10) {
      return {
        taxId: taxId,
        isaComptaCode: "V6",
        productsSold: [
          "70730100",
          "Ventes marchandises TVA 10%"
        ],
        deductibleTax: [
          "4457130100",
          "TVA collectée 10%"
        ]
      };
    }
    if (taxRate === 20) {
      return {
        taxId: taxId,
        isaComptaCode: "V5",
        productsSold: [
          "70720100",
          "Ventes marchandises TVA 20%"
        ],
        deductibleTax: [
          "4457120100",
          "TVA collectée 20%"
        ]
      };
    }
  }
  return {
    taxId: taxId,
    isaComptaCode: undefined,
    productsSold: [
      "",
      ""
    ],
    deductibleTax: [
      "",
      ""
    ]
  };
}

function decodeFromJson$1(json) {
  let dict = Json.decodeDict(json);
  if (dict === undefined) {
    return;
  }
  let taxId = Json.decodeDictFieldString(dict, "taxId");
  let isaComptaCode = Json.decodeDictFieldString(dict, "isaComptaCode");
  let productsSold = Stdlib_Option.flatMap(Stdlib_Option.flatMap(dict["productsSold"], Json.decodeDict), value => {
    let accountNumber = Json.decodeDictFieldString(value, "accountNumber");
    let label = Json.decodeDictFieldString(value, "label");
    if (accountNumber !== undefined && label !== undefined) {
      return [
        accountNumber,
        label
      ];
    }
  });
  let deductibleTax = Stdlib_Option.flatMap(Stdlib_Option.flatMap(dict["deductibleTax"], Json.decodeDict), value => {
    let accountNumber = Json.decodeDictFieldString(value, "accountNumber");
    let label = Json.decodeDictFieldString(value, "label");
    if (accountNumber !== undefined && label !== undefined) {
      return [
        accountNumber,
        label
      ];
    }
  });
  if (taxId !== undefined && productsSold !== undefined) {
    return {
      taxId: taxId,
      isaComptaCode: isaComptaCode,
      productsSold: productsSold,
      deductibleTax: deductibleTax
    };
  }
}

function encodeToJson$1(param) {
  let deductibleTax = param.deductibleTax;
  let productsSold = param.productsSold;
  let isaComptaCode = param.isaComptaCode;
  return Json.encodeDict(Object.fromEntries([
    [
      "taxId",
      Json.encodeString(param.taxId)
    ],
    [
      "isaComptaCode",
      isaComptaCode !== undefined ? Json.encodeString(isaComptaCode) : null
    ],
    [
      "productsSold",
      Json.encodeDict(Object.fromEntries([
        [
          "accountNumber",
          Json.encodeString(productsSold[0])
        ],
        [
          "label",
          Json.encodeString(productsSold[1])
        ]
      ]))
    ],
    [
      "deductibleTax",
      deductibleTax !== undefined ? Json.encodeDict(Object.fromEntries([
          [
            "accountNumber",
            Json.encodeString(deductibleTax[0])
          ],
          [
            "label",
            Json.encodeString(deductibleTax[1])
          ]
        ])) : null
    ]
  ]));
}

let TaxAccount = {
  fillWithStandard: fillWithStandard,
  decodeFromJson: decodeFromJson$1,
  encodeToJson: encodeToJson$1
};

function endpoint(shopId) {
  return Env.gatewayUrl() + "/accounting-export-configurations/" + shopId;
}

function decodeInvalidRequestFailure(error) {
  if (error.kind === "NotFoundAccountingExportConfiguration") {
    return "NotFoundAccountingExportConfigurationFailure";
  } else {
    return "UnknownServerFailure";
  }
}

function decodeRequestError(requestError) {
  let tmp;
  if (typeof requestError !== "object" || requestError.TAG !== "InvalidRequestFailures") {
    tmp = {
      TAG: "Error",
      _0: undefined
    };
  } else {
    let firstFailure = Stdlib_Option.map(requestError._0[0], decodeInvalidRequestFailure);
    tmp = firstFailure === "NotFoundAccountingExportConfigurationFailure" ? ({
        TAG: "Ok",
        _0: undefined
      }) : ({
        TAG: "Error",
        _0: undefined
      });
  }
  return Future.value(tmp);
}

function decodeResponse(response) {
  return Stdlib_Option.flatMap(Json.decodeDict(response), dict => {
    let isaComptaAccountNumber = Json.decodeDictFieldString(dict, "isaComptaAccountNumber");
    let fiscalYearOpeningMonth = Stdlib_Option.flatMap(dict["fiscalYearOpeningMonth"], FiscalYearOpeningMonth.decodeFromJson);
    let taxesAccounts = Stdlib_Option.map(Json.decodeDictFieldArray(dict, "accountingExportTaxAccounts"), value => Stdlib_Array.filterMap(value, decodeFromJson$1));
    let shopId = Json.decodeDictFieldString(dict, "shopId");
    let breakdownOfConsumerSalesByCashRegisterDailyReport = Json.decodeDictFieldBoolean(dict, "breakdownOfConsumerSalesByCashRegisterDailyReport");
    let includeCashFromIndividualsInPaymentJournal = Json.decodeDictFieldBoolean(dict, "includeCashFromIndividualsInPaymentJournal");
    let maybePaymentsAccounts = Stdlib_Option.map(Json.decodeDictFieldArray(dict, "accountingExportPaymentAccounts"), value => Stdlib_Array.filterMap(value, decodeFromJson));
    let maybePaymentsAccounts$1 = maybePaymentsAccounts !== undefined && maybePaymentsAccounts.length !== 0 ? maybePaymentsAccounts : undefined;
    if (shopId !== undefined && fiscalYearOpeningMonth !== undefined && taxesAccounts !== undefined && breakdownOfConsumerSalesByCashRegisterDailyReport !== undefined && includeCashFromIndividualsInPaymentJournal !== undefined && taxesAccounts.length !== 0) {
      return {
        shopId: shopId,
        isaComptaAccountNumber: isaComptaAccountNumber,
        fiscalYearOpeningMonth: fiscalYearOpeningMonth,
        taxesAccounts: taxesAccounts,
        maybePaymentsAccounts: maybePaymentsAccounts$1,
        breakdownOfConsumerSalesByCashRegisterDailyReport: breakdownOfConsumerSalesByCashRegisterDailyReport,
        includeCashFromIndividualsInPaymentJournal: includeCashFromIndividualsInPaymentJournal
      };
    }
  });
}

function request(shopId) {
  return Future.flatMapError(Future.mapOk(Request.make(endpoint(shopId), undefined, undefined, undefined, undefined), undefined, decodeResponse), undefined, decodeRequestError);
}

export {
  PaymentAccount,
  autocompleteBasicPaymentsAccounts,
  TaxAccount,
  endpoint,
  decodeInvalidRequestFailure,
  decodeRequestError,
  decodeResponse,
  request,
}
/* I18n Not a pure module */
